import Layout from "../layout";

// 侧边栏路由
const menuRouter = {
  path: "/index",
  name: "框架",
  component: Layout,
  children: [
    {
      path: "/home",
      name: "首页",
      component: () => import("../views/home"),
      meta: {
        icon: "home.png",
        activeIcon: "home_active.png",
        auth: [],
      },
    },
    {
      path: "/intro",
      name: "公司简介",
      component: () => import("../views/intro"),
      meta: {
        icon: "intro.png",
        activeIcon: "intro_active.png",
        auth: [],
      },
    },
    {
      path: "/manager",
      name: "民宿运营&酒店管理",
      component: () => import("../views/manager"),
      meta: {
        icon: "manager.png",
        activeIcon: "manager_active.png",
        auth: [],
      },
    },
    {
      path: "/investment",
      name: "赴日旅居&投资并购",
      component: () => import("../views/investment"),
      meta: {
        icon: "investment.png",
        activeIcon: "investment_active.png",
        auth: [],
      },
    },
    {
      path: "/development",
      name: "数字营销&IT开发",
      component: () => import("../views/development"),
      meta: {
        icon: "develop.png",
        activeIcon: "develop_active.png",
        auth: [],
      },
    },
    {
      path: "/contact",
      name: "联系我们",
      component: () => import("../views/contact"),
      meta: {
        icon: "contact.png",
        activeIcon: "contact_active.png",
        auth: [],
      },
    },
  ],
};
export default menuRouter;
